import { dew as _parseAccountDew } from "../../accounts/utils/parseAccount.js";
import { dew as _encodeFunctionDataDew } from "../../utils/abi/encodeFunctionData.js";
import { dew as _getContractErrorDew } from "../../utils/errors/getContractError.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _estimateGasDew } from "./estimateGas.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.estimateContractGas = void 0;
  const parseAccount_js_1 = _parseAccountDew();
  const encodeFunctionData_js_1 = _encodeFunctionDataDew();
  const getContractError_js_1 = _getContractErrorDew();
  const getAction_js_1 = _getActionDew();
  const estimateGas_js_1 = _estimateGasDew();
  async function estimateContractGas(client, {
    abi,
    address,
    args,
    functionName,
    ...request
  }) {
    const data = (0, encodeFunctionData_js_1.encodeFunctionData)({
      abi,
      args,
      functionName
    });
    try {
      const gas = await (0, getAction_js_1.getAction)(client, estimateGas_js_1.estimateGas, "estimateGas")({
        data,
        to: address,
        ...request
      });
      return gas;
    } catch (err) {
      const account = request.account ? (0, parseAccount_js_1.parseAccount)(request.account) : undefined;
      throw (0, getContractError_js_1.getContractError)(err, {
        abi: abi,
        address,
        args,
        docsPath: "/docs/contract/estimateContractGas",
        functionName,
        sender: account?.address
      });
    }
  }
  exports.estimateContractGas = estimateContractGas;
  //# sourceMappingURL=estimateContractGas.js.map
  return exports;
}